var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-btn-volume", on: { mouseleave: _vm.closeVolume } },
    [
      _c(
        "transition",
        { attrs: { name: "fade-superfast", mode: "out-in" } },
        [
          _vm.iconPos === "before"
            ? _c(
                "w-btn-icon",
                {
                  key: _vm.icon,
                  attrs: {
                    size: _vm.size,
                    hoverAction: _vm.openVolume,
                    hover: "",
                  },
                  on: { click: _vm.toggleMute },
                },
                [
                  _c(_vm.icon, {
                    tag: "component",
                    attrs: { title: _vm.title },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("w-slider", {
        staticClass: "volume",
        class: { open: _vm.volumeOpen },
        attrs: {
          "no-labels": "",
          max: 100,
          format: function (x) {
            return x + "%"
          },
          value: _vm.value * 100,
        },
        on: { input: _vm.setVolume },
      }),
      _c(
        "transition",
        { attrs: { name: "fade-superfast", mode: "out-in" } },
        [
          _vm.iconPos === "after"
            ? _c(
                "w-btn-icon",
                {
                  key: _vm.icon,
                  attrs: {
                    size: _vm.size,
                    hoverAction: _vm.openVolume,
                    hover: "",
                  },
                  on: { click: _vm.toggleMute },
                },
                [
                  _c(_vm.icon, {
                    tag: "component",
                    attrs: { title: _vm.title },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }